import { BaseFetch } from "../main-model"
export default class PublicUtilitiesModel extends BaseFetch {
    getPublicUtilitiesBy = (data) =>
    this.authFetch({
      url: "public-utilities/getPublicUtilitiesBy",
      method: "POST",
      body: JSON.stringify(data),
    })
    getPublicUtilitiesById = (data) =>
    this.authFetch({
      url: "public-utilities/getPublicUtilitiesById",
      method: "POST",
      body: JSON.stringify(data),
    })
    updatePublicUtilitiesById = (data) =>
    this.authFetch({
      url: "public-utilities/updatePublicUtilitiesById",
      method: "POST",
      body: JSON.stringify(data),
    })
    insertPublicUtilities = (data) =>
    this.authFetch({
      url: "public-utilities/insertPublicUtilities",
      method: "POST",
      body: JSON.stringify(data),
    })
    deletePublicUtilitiesById = (data) =>
    this.authFetch({
      url: "public-utilities/deletePublicUtilitiesById",
      method: "POST",
      body: JSON.stringify(data),
    })
}
